/*
* 转换时间
*/
export function getData(val) {
    let year = val.getFullYear();
    let month = val.getMonth() + 1;
    let day = val.getDate();
    let hour = val.getHours();
    if (month >= 1 && month <= 9) {
        month = `0${month}`;
    }
    if (day >= 1 && day <= 9) {
        day = `0${day}`;
    }
    if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
    }
    return year + "-" + month + "-" + day + " " + hour + ":00"
}


export function getPageLlq() {
    var pageLlq = null
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
                pageLlq = 'miniProgram'
            } else {
                pageLlq = 'wx'
            }
        })
    } else {
        pageLlq = 'nowx'
    }
    return pageLlq;
}


export const hzList = [
    {
        code: 'WISDOM_STAR',
        name: '智慧之星',
        img: require('../assets/img2/hz5.png'),
        proname: '无忧保plus百万医疗保险 （互联网专属）',
        prodesc: '保障全保费低 多人价格实惠',
        proimg: require('../assets/img2/insure1.png'),
        proprice: '188',
    },
    { name: '坚持达人', code: 'PERSISTENCE_MASTER', img: require('../assets/img2/hz1.png') },
    { name: '毅力之星', code: 'WILLPOWER_STAR', img: require('../assets/img2/hz6.png') },
    { name: '幸运之星', code: 'LUCKY_STAR', img: require('../assets/img2/hz2.png') },
    { name: '分享之星', code: 'SHARING_STAR', img: require('../assets/img2/hz3.png') },
    { name: '全能之星', code: ' ALL_ROUNDER_STAR', img: require('../assets/img2/hz4.png') },
]